export const ProjectHistoryType = {
  CRM: 'CRM',
  TASK: 'TASK',
  DAILYREPORT: 'DAILYREPORT',
  ATTACHMENT: 'ATTACHMENT',
  TASKLISTREPORT: 'TASKLISTREPORT',
};

export const ProjectHistoryTypeList = [
  { label: 'CRM', value: ProjectHistoryType.CRM },
  { label: 'Feladat', value: ProjectHistoryType.TASK },
  { label: 'Napi lejelentés', value: ProjectHistoryType.DAILYREPORT },
  { label: 'Csatolmány', value: ProjectHistoryType.ATTACHMENT },
  { label: 'Lejelentés', value: ProjectHistoryType.TASKLISTREPORT },
];
